/* eslint-disable no-console */
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import cx from "classix";
import { Container, LoginFeedback } from "../../components";
import { useAuthContext } from "../../context/auth";
import { login } from "../../utils";
import "./stylesLogin.scss";

export const Login = () => {
  const [status, setStatus] = useState("form");
  const [formVisible, setFormVisible] = useState(true);

  const { pais: contextPais } = useAuthContext(); // Renombramos para claridad

  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm();

  const onSubmit = useCallback(
    async ({ email }) => {
      try {
        if (!email) {
          setStatus("invalid_email");
          console.log("No email, set to invalid_email");
          return;
        }

        // Inferir país basado en el dominio si no está en el context
        let pais = contextPais;
        if (!pais) {
          const domain = window.location.hostname;
          if (domain.includes("wecast.cl")) {
            pais = "Chile";
          } else if (domain.includes("visiona.pe")) {
            pais = "Perú";
          } else {
            pais = null; // O un default si aplica
          }
        }

        setStatus("sending_link");

        let senderEmail;
        if (pais === "Chile") {
          senderEmail = "hola@wecast.cl";
        } else if (pais === "Perú") {
          senderEmail = "hola@visiona.pe";
        } else {
          senderEmail = "default@email.com"; // O maneja error si pais undefined
        }

        // Agrega esto para debug: console.log({ email, pais, senderEmail });
        if (!pais) {
          console.error("Pais no definido en context ni inferido del dominio");
          setStatus("error");
          setFormVisible(true);
          return;
        }

        const isLocalhost = window.location.hostname === "localhost";
        const result = await login({ email, pais, senderEmail, isLocalhost });
        const parsedResult = typeof result === "string" ? JSON.parse(result) : result; // Parse if string

        if (parsedResult.success) {
          setStatus("check_email");
          setFormVisible(false);
        } else if (parsedResult.error === "invalid_email") {
          setStatus("invalid_email");
          setFormVisible(true);
        } else {
          setStatus("error");
          setFormVisible(true);
        }
      } catch (error) {
        console.error("Login onSubmit", error);
        setStatus("error");
        setFormVisible(true);
      }
    },
    [contextPais]
  );

  useEffect(() => {
    if (status === "invalid_email" || status === "error") {
      const timer = setTimeout(() => {
        setStatus("form");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <Container className="Login" header titulo="INICIAR SESIÓN">
      {formVisible && (
        <form className="row g-3 justify-content-md-center" onSubmit={handleSubmit(onSubmit)}>
          <div className="col-6">
            <input
              className={cx("form-control", errors?.email && "is-invalid")}
              id="email"
              placeholder="Ingrese su correo"
              type="email"
              autoComplete="email"
              {...register("email", { required: true })}
            />
            {status === "invalid_email" && (
              <div className="invalid-feedback">El correo ingresado no está autorizado</div>
            )}
          </div>

          <div className="col-12 text-center">
            <button className="botonLogin">ENVIAR</button>
          </div>
        </form>
      )}
      <div className="col-12 text-center" style={{ marginTop: "2rem", minHeight: "100px", display: "block" }}>
        {status === "sending_link" && <div className="loading-message">Enviando enlace...</div>}
        {status === "check_email" && (
          <div className="success-message" style={{ color: "green", fontSize: "1.2rem", display: "block" }}>
            Estamos OK, por favor revisa tu correo para finalizar el login
          </div>
        )}
        {status === "error" && (
          <div className="invalid-feedback" style={{ marginTop: "2rem", fontSize: "1.2rem" }}>
            Ocurrió un error al enviar el enlace. Por favor, intente nuevamente.
          </div>
        )}
        {status !== "form" && status !== "sending_link" && status !== "check_email" && status !== "error" && (
          <LoginFeedback status={status} />
        )}
      </div>
    </Container>
  );
};
